/*
 * @Description: 用户口碑三维度
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-24 15:29:34
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p25.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts/ExportEcharts';

import {getReportBattleDimensions} from '../../../controller';
import {competingGoodsLine, competingGoodsLegend} from '../../../chart';
import { getSessionQuery } from '../../../utils';

class P25 extends React.Component {
  constructor () {
    super();

    this.state = {
      query: {
        brandNames: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        emotion: '',
        participate: '',
        spread: ''
      },
      emotion: {},
      participate: {},
      spread: {},
      legend: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');

    const result = {
      brandNames: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime,
      report: true
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const query = this.getQuery();

    this.setState({
      query: query
    });

    this.getEmotion(query);
    this.getPa0rticipate(query);
    this.getSpread(query);
  }

  /**
   * 获取好感度对比数据
   * @param {*} query
   * @memberof P25
   */
  getEmotion (query) {
    const _query = Object.assign({
      dimensions: 'emotion'
    }, query);
    getReportBattleDimensions(_query)
      .then(data => {
        this.setState({
          summary: Object.assign({}, this.state.summary, {
            emotion: data.brandCompare
          }),
          emotion: competingGoodsLine(data, query, '好感度'),
          legend: competingGoodsLegend(data, query)
        })
      });
  }

  /**
   * 获取参与度对比数据
   * @param {*} query
   * @memberof P25
   */
  getPa0rticipate (query) {
    const _query = Object.assign({
      dimensions: 'participate'
    }, query);
    getReportBattleDimensions(_query)
      .then(data => {
        this.setState({
          summary: Object.assign({}, this.state.summary, {
            participate: data.brandCompare
          }),
          participate: competingGoodsLine(data, query, '参与度')
        })
      });
  }

  /**
   * 获取传播度对比数据
   * @param {*} query
   * @memberof P25
   */
  getSpread (query) {
    const _query = Object.assign({
      dimensions: 'spread'
    }, query);
    getReportBattleDimensions(_query)
      .then(data => {
        this.setState({
          summary: Object.assign({}, this.state.summary, {
            spread: data.brandCompare
          }),
          spread: competingGoodsLine(data, query, '传播度')
        })
      });
  }


  render() {

    const {query, summary} = this.state;

    return (
      <div className={s.container}>
        <ExportHeadTitle>用户口碑三维度 - 重点竞品对比</ExportHeadTitle>

        <div>
          <ExportDes> 好感度对比：{summary.emotion}。参与度对比：{summary.participate}。传播度对比：{summary.spread}。 </ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <div className={s.echartWrapperTop}>
            <div className={s.leftChart}> <ExportEcharts option={this.state.emotion}></ExportEcharts> </div>
            <div className={s.rightChartWrapper}>
              <div className={s.rightChart}> <ExportEcharts option={this.state.participate}></ExportEcharts> </div>
              <div className={s.rightChart}> <ExportEcharts option={this.state.spread}></ExportEcharts> </div>
            </div>
          </div>
          <div className={s.echartWrapperBottom}>
            <ExportEcharts option={this.state.legend}></ExportEcharts>
          </div>
        </div>

        <ExportFootDes
          brandName={query.brandNames}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P25);



// WEBPACK FOOTER //
// src/routes/exportPDF/p25/p25.js